











import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";

@Component({
  components: {}
})
export default class SkuTitle extends Vue {
  @Prop({ default: "follow" })
  private type: any;

  get item() {
    const itemlist: any = {
      follow: {
        icon: "icon-type_follower",
        title: "Followers",
        desc: "Real Instagram followers"
      },
      like: {
        icon: "icon-type_like",
        title: "Likes",
        desc: "Real & fast Instagram likes"
      },
      comment: {
        icon: "icon-type_comment",
        title: "Comments",
        desc: "Real Instagram comments"
      },
      view: {
        icon: "icon-type_view",
        title: "Views",
        desc: "Real Instagram views"
      }
    };
    return itemlist[this.type];
  }
}
